import type { ApiPhoneCall } from '../api/types';
import { reduceCachedPhoneCall } from './phoneCallCachePolicy';

const PENDING_PHONE_CALL_KEY = 'runai_pending_phone_call';

export function storePendingPhoneCallSnapshot(phoneCall: ApiPhoneCall | undefined) {
  const reduced = reduceCachedPhoneCall(phoneCall);
  if (!reduced) {
    localStorage.removeItem(PENDING_PHONE_CALL_KEY);
    return;
  }

  localStorage.setItem(PENDING_PHONE_CALL_KEY, JSON.stringify(reduced));
}

export function loadPendingPhoneCallSnapshot(): ApiPhoneCall | undefined {
  const raw = localStorage.getItem(PENDING_PHONE_CALL_KEY);
  if (!raw) {
    return undefined;
  }

  try {
    return JSON.parse(raw) as ApiPhoneCall;
  } catch {
    localStorage.removeItem(PENDING_PHONE_CALL_KEY);
    return undefined;
  }
}

export function clearPendingPhoneCallSnapshot() {
  localStorage.removeItem(PENDING_PHONE_CALL_KEY);
}
